module.exports = __webpack_public_path__ + "static/frenchie-bd35f2e1f950e58f9e3a0f55b1e0c864.jpg";